export default {
  v1Testimonials: 'v1Testimonials',
  submitClaim: 'submitClaim',
  validateStore: 'validateStore',
  retrieveStoreStats: 'retrieveStoreStats',
  retrieveUserStats: 'retrieveUserStats',
  dashboardStats: 'dashboardStats',
  listAllAppointments: 'listAllAppointments',
  editAppointment: 'editAppointment',
  cancelAppointment: 'cancelAppointment',
  createAppointment: 'createAppointment',
  usedAppointmentTimeSlots: 'usedAppointmentTimeSlots',
  csdb: 'csdb',
  vhtAddAppointment: 'vhtAddAppointment',
  vhtGetNextAvailableAppointmentTime: 'vhtGetNextAvailableAppointmentTime',
  experiencesVhtGetNextAvailableAppointmentTime: 'experiencesVhtGetNextAvailableAppointmentTime',
  sendV1IdAndVhtId: 'sendV1IdAndVhtId',
  feedback: 'feedback',
  reporting: 'reporting',
  getAppointment: 'getAppointment',
  getAtlasId: 'getAtlasId',
  retrieveQuotesAndTips: 'retrieveQuotesAndTips',
  getCustomerByMdn: 'getCustomerByMdn',
  survey: 'survey',
  joinResearch: 'joinResearch',
  decrypt: 'decrypt',
  fonoApiUrl: 'fonoApiUrl',
  leaderBoard: 'leaderBoard',
  campaignDetails: 'campaignDetails',
  expertSessionsAppointment: 'expertSessionsAppointment',
  expertSessionsFeedback: 'expertSessionsFeedback',
  expertSessionsJoinResearch: 'expertSessionsJoinResearch',
  unsubscribe: 'unsubscribe',
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/restApiNames.js